import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Header.css";

const Header = ({ scrollToSection }) => {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleLogin = () => {
    window.location.href = "https://app.nestpedia.info/login";
  };

  const handleNavClick = (section) => {
    setIsMenuOpen(false);
    scrollToSection(section);
  };

  return (
    <header className="landing-header">
      <div className="header-container">
        {/* Logo */}
        <div className="logo" onClick={() => scrollToSection("hero")} style={{ cursor: "pointer" }}>
          <span className="logo-badge">TRAVNOK</span>
          <span className="logo-sub">CRM</span>
        </div>

        {/* Navigation Menu */}
        <nav className={`nav-menu ${isMenuOpen ? "active" : ""}`}>
          <a
            href="#interactive-showcase"
            onClick={(e) => {
              e.preventDefault();
              handleNavClick("interactive-showcase");
            }}
          >
            Product Tour
          </a>
          <a
            href="#features"
            onClick={(e) => {
              e.preventDefault();
              handleNavClick("features");
            }}
          >
            Features
          </a>
          <a
            href="#roi-calculator"
            onClick={(e) => {
              e.preventDefault();
              handleNavClick("roi-calculator");
            }}
          >
            ROI Calculator
          </a>
          <a
            href="#faq"
            onClick={(e) => {
              e.preventDefault();
              handleNavClick("faq");
            }}
          >
            FAQ
          </a>
          <a
            href="#demo-form"
            onClick={(e) => {
              e.preventDefault();
              handleNavClick("demo-form");
            }}
            className="cta-button"
          >
            Book Demo
          </a>
        </nav>

        {/* Header Actions */}
        <div className="header-actions">
          <button className="login-btn" onClick={handleLogin}>
            Login
          </button>
          <button
            className="mobile-menu-toggle"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle navigation menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
